import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../shared/utils/CustomPagination';
import { useApartmentCourses } from './../../assets/api/useApartmentApi';
import { Typography } from '@mui/material';
import { useState } from 'react';
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';

const StudentCourseTable = ({ id }) => {
    const { data: CourseList, isLoading: isCourseListLoading } = useApartmentCourses(id)
    const [coursePaginationModel, setCoursePaginationModel] = useState({ page: 0, pageSize: 5 });
    const courseRows = CourseList?.data?.map((item, index) => ({
        id: index + 1,
        sr_no: index + 1,
        ...item
    })) || [];
    const CourseColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 0.5,
            renderCell: (params) => <Typography variant="body1">{params.value}</Typography>
        },
        {
            field: "title",
            headerName: "Course Name",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" my={2} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "student_count",
            headerName: "Student Count",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "start_date",
            headerName: "Start Date",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "end_date",
            headerName: "End Date",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        // {
        //   field: "start_time",
        //   headerName: "Start Time",
        //   flex: 1.5,
        //   renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        // },
        // {
        //   field: "end_time",
        //   headerName: "End Time",
        //   flex: 1.5,
        //   renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        // }




    ];
    return (
        <>
            {isCourseListLoading ? (
                <DataGridSkeleton rowsNum={5} />
            ) : (
                <DataGrid
                    rows={courseRows}
                    columns={CourseColumns}
                    pagination
                    paginationModel={coursePaginationModel}
                    onPaginationModelChange={setCoursePaginationModel}
                    pageSizeOptions={[5]}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={coursePaginationModel}
                                setPaginationModel={setCoursePaginationModel}
                                totalRows={courseRows?.length || 0}
                                pageSize={coursePaginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )}

        </>
    )
}

export default StudentCourseTable